import type { Locale } from "@commerce-frontend/i18n/types";
import { type ArticleOverviewFragmentFragment, graphql } from "@commerce-frontend/types";
import { ArticleGrid } from "@commerce-frontend/ui/components/ArticleGrid/ArticleGrid";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import type { HTMLAttributes } from "react";
import { ArticleCard } from "~/components/ArticleCard/ArticleCard";
import { Pagination } from "~/components/Pagination/Pagination";
import { deserializePageState } from "~/lib/page-state";

graphql(/* GraphQL */ `
	fragment ArticleOverviewFragment on ArticleOverview {
		__typename
		id
		articleItems: items(page: $currentPage) {
			totalPages
			results {
				...ArticleCardFragment
			}
		}
	}
`);

type Props = {
	data: ArticleOverviewFragmentFragment;
	locale: Locale;
	searchParams: URLSearchParams;
} & HTMLAttributes<HTMLDivElement>;

export const ArticleOverview = ({ className, data, locale, searchParams }: Props) => {
	const pageState = deserializePageState(searchParams);
	const { articleItems } = data;

	if (!articleItems.results?.length) {
		return null;
	}

	return (
		<>
			<ArticleGrid className={cn(["", className])}>
				{articleItems?.results?.map(
					(article) =>
						article && <ArticleCard key={article?.id} article={article} locale={locale} />,
				)}
			</ArticleGrid>

			{articleItems?.totalPages > 1 && (
				<div className="mt-5xl pt-2xl border-t border-gray-300">
					<Pagination
						locale={locale}
						currentPage={pageState.page}
						totalPages={articleItems?.totalPages}
					/>
				</div>
			)}
		</>
	);
};
